import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n";

// Claude: alpha-tester feedback — "Pending content appears in ordinary public search... the result
// Claude: card gives no status warning." Pending (unreviewed) terms deliberately stay visible in
// Claude: search for now (nearly the whole imported dataset is still PND), so each pending result
// Claude: row gets this badge instead. Labelled "Unverified" (own i18n key) rather than the internal
// Claude: "Pending" status name, per instruction — clearer to a visitor unfamiliar with the review
// Claude: workflow. Renders nothing for any other status.
function PendingBadge({ status }) {
  const { t } = useTranslation();
  if (status !== "PND") {
    return null;
  }
  return (
    <span
      data-testid="pending-badge"
      className="inline-block ml-2 align-middle bg-amber-100 text-amber-800 text-xs font-semibold px-2 py-0.5 rounded border border-amber-300"
    >
      {t("unverified")}
    </span>
  );
}

export default PendingBadge;
